module.exports = __webpack_public_path__ + "static/media/US.7de5860f.svg";